import { Title } from '@atom/typography/typography';
import { RequestLogs } from '@component/tables/request-logs/request-logs';

export const ConsumerLogs = () => (
  <>
    <Title level={3} mb={16} weight={400}>
      Logs
    </Title>
    <RequestLogs />
  </>
);
